'use strict';

const timer = require('./components/timer');
const copyToClipboard = require('./components/copyToClipboard');
const notify = require('./components/notify');
const initMobileKeybordEvent = require('./components/mobileKeybord');
const detectTabMgr = require('./components/detectTabMgr');
const debug = require('./components/debug');

const ECUX = {
    _CURRENT_VERSION: '25.10.2' // YEAR.Month.*** change version
}

window.ecux = {
    notify: notify,
    timer: timer,
    detectTabMgr: detectTabMgr,
    debug: debug,
    version: ECUX._CURRENT_VERSION
};

window.ecux.init = function () {
    initMobileKeybordEvent.init();
    copyToClipboard.init();
    debug.init();
    console.info('[ECUX] initialized');
}

window.ecux.init();
